/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForJiraServicedesk extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForJiraServicedesk");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForJiraServicedesk.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForJiraServicedesk>): ServiceAccountCredentialsForJiraServicedesk {
        let obj = Object.assign(new ServiceAccountCredentialsForJiraServicedesk(), model);
        ServiceAccountCredentialsForJiraServicedesk.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForJiraServicedesk>): ServiceAccountCredentialsForJiraServicedesk {
        if (!model) return null;
        return ServiceAccountCredentialsForJiraServicedesk.newInstance(<ServiceAccountCredentialsForJiraServicedesk> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForJiraServicedesk) {
        if (!obj) return;

        models.ServiceAccountCredentialsForJiraServicedesk.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForJiraServicedesk): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForJiraServicedesk.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * API Token. This is a required field.
     */
    api_token: string;

    /**
     * Auth URL. This is a required field.
     */
    auth_url: string;

}
